import { createReducer } from '@topconagriculture/frontend-utils';
import * as dotProp from 'dot-prop-immutable';
import { getBillableCountries, getCountries } from './country.actions';
export const initialState = { countries: [], billableCountries: [] };
const countryReducer = createReducer(initialState, {
    [getCountries.done.type]: (state, action) => dotProp.set(state, 'countries', action.payload.result),
    [getBillableCountries.done.type]: (state, action) => dotProp.set(state, 'billableCountries', action.payload.result),
});
export default { country: countryReducer };
//# sourceMappingURL=country.reducer.js.map